import React from 'react'
import Button from '../../../../lib/ui/Buttons/Button'
import styles from './Newsletters.module.sass'
import Typography from '../../../../lib/ui/Typography/index'
import BasicLoader from '../../../../lib/ui/BasicLoader/BasicLoader'
import ToggleLabel from '../ToggleLabel/index'
import { siteName } from '../../../../utils/oneCodeBase'
import useOnboardingNewsletters from './useOnboardingNewsletters'
import cx from 'classnames'

const NewsletterToggles = ({
  newsletters,
  type,
  onToggleChange,
  description,
  containerStyle
}) => {
  return (
    <div className={containerStyle}>
      {description && (
        <Typography className={styles.description}>{description}</Typography>
      )}
      <div className={styles.nlSections}>
        {newsletters?.map(item => (
          <ToggleLabel
            checked={item.checked}
            onToggleChange={onToggleChange}
            type={type}
            key={`${type}-${item.id}-toggle`}
            name={item.name}
            id={item.id}
            frequency={item.frequency_description}
            disabled={item.disabled}
          />
        ))}
      </div>
    </div>
  )
}

const Newsletters = ({ configNewsletters, user, pageDescription, siteId }) => {
  const {
    loading,
    freeNewsletters,
    plusNewsletters,
    reportsNewsletters,
    emptyChecked,
    submitNewsletters,
    onToggleChange
  } = useOnboardingNewsletters({ configNewsletters, user })

  return (
    <>
      {loading && <BasicLoader />}

      <div>
        <div
          className={cx(
            styles.parentContainer,
            siteId == 4 ? styles.fwReportsContainer : null
          )}
        >
          {!!freeNewsletters?.length && (
            <NewsletterToggles
              newsletters={freeNewsletters}
              type="free"
              onToggleChange={onToggleChange}
              description={pageDescription}
            />
          )}

          {!!plusNewsletters?.length && (
            <NewsletterToggles
              newsletters={plusNewsletters}
              type="plus"
              onToggleChange={onToggleChange}
              description={`Exclusive to FirstWord ${siteName}+ subscribers`}
            />
          )}

          {/* Render report newsletters section at the top in FW Reports */}
          {!!reportsNewsletters?.length && (
            <NewsletterToggles
              newsletters={reportsNewsletters}
              type="reports"
              onToggleChange={onToggleChange}
              description={`Stay on top of the latest research with KOLs, industry experts, and treating physicians`}
              containerStyle={styles.reportsContainer}
            />
          )}
        </div>
        {(!!freeNewsletters?.length || !!plusNewsletters?.length) && (
          <>
            {emptyChecked && (
              <Typography className={styles.emptyChecked}>
                * Please select a newsletter
              </Typography>
            )}
            <Button
              className={styles.button}
              tier={'secondary'}
              onClick={submitNewsletters}
              textCase="uppercase"
              text={'Confirm'}
            />
          </>
        )}
      </div>
    </>
  )
}

export default Newsletters
